import useGetMoneyPoolManagement from 'pages/fund/fundPage/hooks/useGetMoneyPoolManagement'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

export default function Share() {
    const { id } = useParams()
    const { moneyPoolManagement } = useGetMoneyPoolManagement(id)
    return (
        <div>
            <p className=" text-center mb-3">
                اشتراک گذاری لینک پرداخت حق عضویت
            </p>
            <hr />
            <div className=" my-4 px-3">
                <p
                    onClick={() => {
                        navigator.clipboard.writeText(
                            `${moneyPoolManagement?.short_url}`
                        )
                        toast.success('با موفقیت کپی شد')
                    }}
                >
                    کپی لینک
                </p>
            </div>
        </div>
    )
}
